import AuthenticationLayout from '@/components/layouts/authentication';
import { Box, AppBar, Container, Link, Typography, Grid, Paper, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Head from 'next/head';
import { ReactNode, useState, useEffect } from 'react';
import Logo from '../../components/Logo';
import { SubscriptionPlan } from '@/lib/api/types/SubscriptionPlan';
import useApi from '@/hooks/useApi';
import { useUser } from '@/contexts/UserContext';
import { useRouter } from 'next/router';

const Pricing = () => {
    const theme = useTheme();
    const [plans, setPlans] = useState<SubscriptionPlan[]>([]);
    const api = useApi();
    const { user, setUser } = useUser();
    const router = useRouter();

    const handleButtonClick = (planId: number) => {
        router.push(`/pricing/${planId}`);
    };

    const fetchSubscriptionPlans = async () => {
        try {
            const response = await api.subscriptionPlans.getSubscriptionPlans(); // No need to cast as SubscriptionPlan[]

            if (response) {
                // @ts-ignore
                const data: SubscriptionPlan[] = response.data;
                setPlans(data);
            }
        } catch (error) {
            console.error('Error fetching subscription plans:', error);
        }
    };

    useEffect(() => {
        fetchSubscriptionPlans();
    }, []);

    console.log(plans, 'plans')

    return (
        <>
            <Head>
                <title>Pricing | Spectacle</title>
            </Head>
            <AppBar
                position="static"
                elevation={5}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 100,
                    backgroundColor: theme.palette.background.default,
                }}
            >
                <Link href="/" sx={{ mt: 8 }}>
                    <Logo />
                </Link>
            </AppBar>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.default,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Container maxWidth="lg" sx={{ py: '80px' }}>
                    <Typography color="textPrimary" gutterBottom variant="h2" style={{ fontSize: 36, fontWeight: 700, textAlign: 'center' }}>
                        Pricing Plans
                    </Typography>
                    {!user && (
                        <>
                            <Typography color="textSecondary" variant="body2" sx={{ textAlign: 'center' }}>
                                Don&apos;t have an account? &nbsp;
                                <Link href="/authentication/register" sx={{ color: 'orpheus.pink', fontWeight: 700, textDecoration: 'none' }}>
                                    Sign up.
                                </Link>
                            </Typography>
                            <Typography color="textSecondary" variant="body2" sx={{ mb: 2, textAlign: 'center' }}>
                                Already have an account? <Link href={"/authentication/login"} sx={{ color: 'orpheus.pink', fontWeight: 700, textDecoration: 'none' }}>Log In.</Link>
                            </Typography>
                        </>
                    )}
                    <Grid container spacing={4} justifyContent="center" marginTop={4}>
                        {plans.length > 0 && plans.map((plan, index) => (
                            <Grid item key={index} xs={12} md={4}>
                                <Paper sx={{
                                    p: '25px',
                                    borderRadius: '16px',
                                    backgroundColor: plan.attributes.name === "Monthly" ? '#d3d3d3' : 'initial',
                                    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.08)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    height: '100%',
                                    alignItems: 'stretch',
                                }}>
                                    <Box>
                                        < Typography gutterBottom style={{ fontFamily: 'Montserrat', fontSize: 24, fontWeight: 600 }}>
                                            {plan.attributes.name}
                                        </Typography>
                                        {
                                            plan.attributes.name === "Monthly" && (
                                                <Typography gutterBottom style={{ fontFamily: 'Montserrat', fontSize: 16, fontWeight: 600 }}>
                                                    Starting at
                                                </Typography>
                                            )
                                        }
                                        < Typography gutterBottom style={{ fontFamily: 'Dunbar Tall', fontWeight: 600, fontSize: 36 }}>
                                            {plan.attributes.prices.length > 0 ? (
                                                <span>
                                                    <span>${plan.attributes.prices[0].unit_amount}</span>
                                                    <span style={{ fontFamily: 'Montserrat', fontWeight: 400, fontSize: 16 }}>{plan.attributes.prices[0].billing_scheme}</span>
                                                </span>
                                            ) : "Contact Us"}
                                        </Typography>
                                    </Box>
                                    <ul>
                                        {plan.attributes.features.map((feature, index) => (
                                            <li key={index} style={{ fontFamily: 'Montserrat', fontSize: 16, fontWeight: 500, lineHeight: 1.8 }}>{feature.name}</li>
                                        ))}
                                    </ul>
                                    <Button
                                        disabled={plan.attributes.name === "Monthly"}
                                        component="a"
                                        href={
                                            plan.attributes.name === "Enterprise"
                                                ? 'https://www.thespectacleapp.com/contact/'
                                                : '/pricing'
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            borderRadius: '8px',
                                            backgroundColor: plan.attributes.name === "Monthly" ? 'gray' : '#9747FF',
                                            color: 'white',
                                            width: '100%',
                                            '&:hover': {
                                                backgroundColor: '#7B38CC',
                                            },
                                        }}
                                        onClick={(e) => {
                                            if (plan.attributes.name !== "Enterprise") {
                                                e.preventDefault();
                                                handleButtonClick(plan.id);
                                            }
                                        }}
                                    >
                                        {plan.attributes.name === "Monthly" ? 'Coming Soon' : 'Get Started'}
                                    </Button>
                                </Paper>
                                {/* {plan.attributes.name === "Monthly" && (
                                    <Box style={{ marginTop: 10, display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
                                        <Image src="/arrow.png" alt="Arrow" width={25} height={25} style={{ marginRight: '10px' }} />
                                        <div style={{ fontFamily: 'Dunbar Tall', fontSize: 24, fontWeight: 500 }}>Best Deal!</div>
                                    </Box>
                                )} */}
                            </Grid>
                        ))}
                    </Grid >
                </Container >
            </Box >
        </>
    );
};

Pricing.getLayout = function getLayout(page: ReactNode) {
    return (
        <AuthenticationLayout>
            {page}
        </AuthenticationLayout>
    );
};
export default Pricing;
